import React from 'react';
import PropTypes from 'prop-types';
import StyledSvg from '../styledSvg';

const IconFonctionPublique = ({ color, size }) => (
  <StyledSvg fill={color} size={size} viewBox="0 0 48 50" xmlns="http://www.w3.org/2000/svg">
  <g stroke="#B68962" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M5.073 24.796V44.32h4.068V24.796M16.467 24.796V44.32h4.068V24.796M27.864 24.796V44.32h4.068V24.796M39.258 24.796V44.32h4.067V24.796M1.805 44.321H46.58v4.066H1.805zM46.58 20.73v4.066H1.805V20.73M1.805 20.73l22.387-8.26 22.388 8.26M24.192 12.47V1.74M24.192 1.74h4.881v5.772h-4.881zM29.073 3.367h4.881v5.772h-4.881z"/></g>
  </StyledSvg>
);

IconFonctionPublique.propTypes = {
  /** Should be a valid css color in a string */
  color: PropTypes.string,
  /** Should be a the value in px */
  size: PropTypes.number,
};

IconFonctionPublique.defaultProps = {
  color: '#000',
  size: 50,
};

export default IconFonctionPublique;



// WEBPACK FOOTER //
// ./src/app/components/icons/IconFonctionPublique.jsx